import api from "./api";

function hasIdAndSecret(data) {
  return (
    data && typeof data.id === "string" && typeof data.clientData === "string"
  );
}

export async function getThirdPartyPayment(id) {
  try {
    const response = await api.get(`api/thirdpartypayments/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error getting third party payment", error);
    return null;
  }
}

export async function createThirdPartyPayment(parameters) {
  try {
    const res = await api.post("api/ThirdPartyPayments", {
      merchantId: parameters.merchantId,
      clientData: parameters.clientData,
      paymentRequestId: parameters.paymentRequestId,
      customerId: parameters.customerId,
      orderNumber: parameters.orderNumber,
      checkoutId: parameters.checkoutId,
      customerName: parameters.customerName,
      amount: parameters.amount,
      reference: parameters.reference,
      source: parameters.source,
      branchId: parameters.branchId,
      customerEmail: parameters.customerEmail,
      customerIsFinanced: parameters.customerIsFinanced,
      paymentProvider: parameters.paymentProvider,
      paymentType: parameters.paymentType,
      ledgerTransactionIds: parameters.transactionIds,
      salesOrderIds: parameters.salesOrderIds,
      discounts: parameters.paymentDiscounts ?? null,
      token: parameters.paymentRequestToken ?? parameters.checkoutToken ?? null,
    });

    if (hasIdAndSecret(res.data)) {
      return res.data; // good payload → stop retrying
    }
    return null; // body missing fields → retry
  } catch (err) {
    // Network / CORS: err.response is *undefined*
    if (!err.response) {
      return null; // retry
    }

    if (err.response.status === 401 && err.response.data?.code === "TokenExpired")
      return { tokenExpired: true };

    // 4xx / 5xx reached the server – DON'T retry
    return err.response.data ?? { status: err.response.status };
  }
}

export async function initThirdPartyPayment(parameters) {
  try {
    const res = await api.post("api/thirdpartypayments/init", {
      merchantId: parameters.merchantId,
      amount: parameters.amount,
      paymentType: parameters.paymentType,
      paymentProvider: parameters.paymentProvider,
      customerIsFinanced: parameters.customerIsFinanced,
    });

    return res.data;
  } catch (err) {
    // Network / CORS: err.response is *undefined*
    if (!err.response) {
      return null; // retry
    }

    // 4xx / 5xx reached the server – DON'T retry
    return err.response.data ?? { status: err.response.status };
  }
}

export async function finalizeThirdPartyPayment(parameters) {
  try {
    const res = await api.post("api/thirdpartypayments/finalize", {
      merchantId: parameters.merchantId,
      clientData: parameters.clientData,
      paymentProvider: parameters.paymentProvider,
      paymentId: parameters.paymentId,
    });

    return res.data;
  } catch (err) {
    // Network / CORS: err.response is *undefined*
    if (!err.response) {
      return null; // retry
    }

    // 4xx / 5xx reached the server – DON'T retry
    return err.response.data ?? { status: err.response.status };
  }
}
